/**
 * Kunci pembanding nama kategori: spasi dirapatkan, tepi dipangkas, huruf kecil.
 *
 * `products.category` hanya SNAPSHOT TEKS (bukan FK), jadi "Gamis", "gamis " dan
 * "GAMIS  " harus dianggap satu kategori. KEMBAR SQL: `public.category_key(text)`
 * (`lower(btrim(regexp_replace(x, '[[:space:]]+', ' ', 'g')))`) dan normalisasi
 * `tiktok_category_maps.category_key` — geser ketiganya bersama.
 *
 * Catatan: `\s` JavaScript juga merapatkan NBSP, sedangkan `[[:space:]]`
 * Postgres bergantung pada locale. Selisih ini hanya muncul pada teks ber-NBSP;
 * angka yang menentukan (jumlah produk, pencocokan saat simpan) selalu dari SQL.
 */
export function categoryKey(value: string | null | undefined): string {
  return (value ?? "").replace(/\s+/g, " ").trim().toLowerCase();
}
